var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticStyle:{"width":"2rem"},attrs:{"src":require('@/assets/images/logo/frio-logo-dark.png')}})}
var staticRenderFns = []

export { render, staticRenderFns }